import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button, FormGroup, Navbar, Breadcrumb } from "react-bootstrap";
import "../add-details.css";

import { connect } from "react-redux";
import { isEmpty, find, isUndefined, filter } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { IconButton } from "@material-ui/core";
import Select from "react-select";
import Swal from "sweetalert";
import { getVendorData } from "../Vendor/Vendor.action";
import { setHeading } from "../../../accounts/account.actions";
import IconMenu from "../../../drawer/IconMenu";
import { Link } from "react-router-dom";
import { getCustomerData } from "../AddCustomer/Customer.action";
import { generatePaymentReportPDF } from "./Reporting.action";
// import { addReceiving, getPDFById, getReceiving } from "./Receiving.action";

const DailyPaymentReport = (props) => {
  const [salesMenId, setSalesMenId] = useState('');
  const [salesMenName, setSalesMenName] = useState("");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  function uploadPurchase() {
    //   props.getReceivingPdf(ReceivingId);
    props.generatePaymentReportPDF({
      startDate: startDate,
      endDate: endDate,
      salesmenId: ""
    },startDate,endDate,salesMenName);
    // setStartDate("")
    // setEndDate("")
    setSalesMenId("")
    setSalesMenName("")
  }

  const getVendorList =
    !isEmpty(props.vendorDataList) &&
    props.vendorDataList.map((x) => {
      let data = { value: x._id, label: x.vendorName };
      return data;
    });
  const handleChangeSalesMen = (selectedOption) => {
    setSalesMenId(selectedOption.value);
    setSalesMenName(selectedOption.label);
  };
  const SalesMenList =
    !isEmpty(props.customerDataList) &&
    props.customerDataList.map((x) => {
      let data = { value: x._id, label: x.name };
      return data;
    });
  useEffect(() => {
    props.setHeading("Payment Report");
    // props.getCustomerData();
  }, []);

  return (
    <>
      <Navbar style={{ backgroundColor: '#81abd3' }}  >
        <Container>
          <Navbar.Brand style={{ color: 'white' }}><b>Payment Report</b></Navbar.Brand>
          <IconMenu />
        </Container>
      </Navbar>
      {props.isFetchingCustomer ? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
            {props.isFetchingReceiving ? "Loading..." : "Loading..."}
          </Button>
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <Row>
              <Breadcrumb>
                <Breadcrumb.Item ><Link to="/home"> Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item ><Link to="/report">Report</Link> </Breadcrumb.Item>
                <Breadcrumb.Item active>Payment Report With Date</Breadcrumb.Item>
              </Breadcrumb>
            </Row>
            <Row>
              <Col >
                <Form.Group>
                  <Form.Label>
                    <b>  Date </b>
                  </Form.Label>
                  <Form.Control
                    value={startDate}
                    type="date"
                    onChange={(e) => setStartDate(e.target.value)}
                  >
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col >
                <Form.Group>
                  <Form.Label>
                    <b> End Date</b>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  >
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <div className="sendDiv" style={{ marginTop: 15 }}>
              {startDate == '' || endDate == '' ? (
                <Button disabled>Generate PDF</Button>
              ) : (
                <Button onClick={uploadPurchase}>Generate PDF</Button>
              )}
            </div>
          </div>
        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    // getReceiving:()=>dispatch(getReceiving()),
    // getReceivingPdf:(id)=>dispatch(getPDFById(id)),
    getVendorData: () => dispatch(getVendorData()),
    generatePaymentReportPDF: (data,startDate,endDate,salesMenName) =>
      dispatch(generatePaymentReportPDF(data,startDate,endDate,salesMenName)),
    setHeading: (data) => dispatch(setHeading(data)),
    getCustomerData: () => dispatch(getCustomerData()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  // ReceivingList:state.RecivingReducer.ReceivingList,
  // isFetchingReceiving:state.RecivingReducer.isFetchingReceiving,
  customerDataList: state.CustomerReducer.customerDataList,
  isFetchingCustomer: state.CustomerReducer.isFetchingCustomer,
  purchaseVendorPDFList: state.RecivingReducer.purchaseVendorPDFList,
  isFetchingPurchaseVendorPDF:
    state.RecivingReducer.isFetchingPurchaseVendorPDF,
  vendorDataList: state.VendorReducer.vendorDataList,
  isFetchingVendor: state.VendorReducer.isFetchingVendor,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DailyPaymentReport);
